import { ThemeDefaults } from "@di-devs/constants";
import { Tag } from "antd";
import moment from "moment";

interface MemberAttribute {
	memberAttributeId: number;
	type: string;
	label: string;
}

export interface RenderSearchConditionMemberAttributeTagProps {
	conditionName: string;
	conditionValue: string | number | boolean | Date;
	memberAttributes: MemberAttribute[];
}

export const renderSearchConditionMemberAttributeTag = ({
	conditionName,
	conditionValue,
	memberAttributes,
}: RenderSearchConditionMemberAttributeTagProps) => {
	let actualId: number = Number.NEGATIVE_INFINITY;
	let rangeLabel = "";
	let childrenContent = <></>;

	const memberAttributeId = conditionName.substring(
		"memberAttributeFilter".length,
	);

	if (memberAttributeId.endsWith("Min")) {
		actualId = Number(
			memberAttributeId.substring(0, memberAttributeId.length - 3),
		);
		rangeLabel = "から";
	} else if (memberAttributeId.endsWith("Max")) {
		actualId = Number(
			memberAttributeId.substring(0, memberAttributeId.length - 3),
		);
		rangeLabel = "まで";
	} else {
		actualId = Number(memberAttributeId);
	}

	const memberAttribute = memberAttributes.find(
		(item: any) => item?.memberAttributeId === actualId,
	);

	if (Number.isNaN(actualId) || !memberAttribute) return;
	const { type, label } = memberAttribute;

	switch (type) {
		case "address":
		case "text":
		case "textarea":
		case "color":
		case "url":
		case "email":
		case "telephone":
		case "firstName":
		case "lastName":
		case "firstNameKana":
		case "lastNameKana":
		case "address_postal":
		case "address_prefecture":
		case "address_city":
		case "address_address":
		case "address_building": {
			childrenContent = (
				<Tag color={ThemeDefaults.CUSTOM_GREEN} className="text-wrap">
					{label}：{conditionValue ? String(conditionValue) : "ー"}
				</Tag>
			);
			break;
		}
		case "number_integer":
		case "number_float": {
			childrenContent = (
				<Tag color={ThemeDefaults.CUSTOM_GREEN} className="text-wrap">
					{label + rangeLabel}：{conditionValue ? String(conditionValue) : "ー"}
				</Tag>
			);
			break;
		}
		case "date":
		case "time":
		case "datetime": {
			childrenContent = (
				<Tag
					color={
						rangeLabel === "から"
							? ThemeDefaults.CUSTOM_GREEN
							: ThemeDefaults.CUSTOM_RED
					}
					className="text-wrap"
				>
					{label + rangeLabel}：
					{conditionValue
						? moment(String(conditionValue)).format("YYYY年M月D日")
						: "ー"}
				</Tag>
			);
			break;
		}
		case "checkbox":
		case "radio":
		case "select": {
			childrenContent = (
				<Tag color={ThemeDefaults.CUSTOM_GREEN} className="text-wrap">
					{label}：
					{conditionValue && Array.isArray(conditionValue)
						? conditionValue.join(",")
						: "ー"}
				</Tag>
			);
			break;
		}
		case "image": {
			childrenContent = (
				<Tag color={ThemeDefaults.CUSTOM_GREEN} className="text-wrap">
					{label}：{conditionValue === "hasImage" ? "有り" : "無し"}
				</Tag>
			);
			break;
		}
	}
	return <p className="p-1 m-1 rounded bg-amber-50">{childrenContent}</p>;
};
